<template>
  <b-col class="paypal-container d-flex flex-column justify-content-around">
    <b-row class="mx-4">
      <b-col>
        {{ $t('purchase.paypal.form.titleForm') }}
      </b-col>
    </b-row>
    <b-row>
      <b-col>
        <form
          ref="formPaypal"
          class="d-none"
          action="https://www.paypal.com/cgi-bin/webscr"
          method="post"
          target="_top"
        >
          <input type="hidden" name="cmd" value="_s-xclick" />
          <input type="hidden" name="hosted_button_id" :value="openPlan.paypalButtonId" />
          <input type="hidden" name="lc" value="US" />
          <input type="hidden" name="no_note" value="1" />
          <input type="hidden" name="currency_code" value="USD" />
          <input type="hidden" name="item_name" :value="vectorName" />
          <input id="item_number" type="hidden" name="item_number" :value="vectorId" />
          <input type="hidden" name="custom" :value="custom" />
          <input type="hidden" name="business" value="billing@lateralcreativa.com" />
          <input type="hidden" value="2" name="rm" />
          <input type="hidden" name="return" :value="buildUrl('payment-successful')" />
          <input type="hidden" name="cancel_return" :value="buildUrl('paypal-cancelled')" />
          <input type="hidden" name="notify_url" :value="buildUrl('paypal-payment')" />
        </form>
      </b-col>
    </b-row>
    <b-row class="mx-4">
      <b-col>
        <b-row>
          <b-col>
            <span>{{ $t('purchase.paypal.form.amount') }}:</span>
            <span class="data-text">USD {{ openPlan.cost }}{{ periodAv }}</span>
          </b-col>
        </b-row>
        <b-row>
          <b-col>
            <span>{{ $t('purchase.paypal.form.plan') }}:</span>
            <span class="data-text">{{ openPlan.name }}</span>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-row align-h="end" class="mx-4">
      <b-col cols="auto">
        <Button color="green" @click="submitFormPayPal">
          <span>{{ $t('purchase.paypal.form.next') }}</span>
          <Icon icon="bootstrap-chevron-right" :width="15" :height="15" />
        </Button>
      </b-col>
    </b-row>
    <b-row v-if="error">
      <b-col class="mx-4">
        <div class="text-danger small">
          {{ $t('contact.form.main.errorSubmiting') }}
        </div>
      </b-col>
    </b-row>
  </b-col>
</template>

<script>
import { mapState } from 'vuex';
import Button from 'UI/Button';
import Icon from 'UI/Icon';
export default {
  components: {
    Button,
    Icon
  },
  data: () => {
    return {
      custom: '',
      error: false
    };
  },
  computed: {
    ...mapState('plans', ['openPlan']),
    ...mapState('vectors', ['actualVector', 'actualVectorId']),
    vectorName() {
      return this.actualVector ? this.actualVector.name : this.openPlan.name;
    },
    vectorId() {
      return this.actualVectorId ? this.actualVectorId : '';
    },
    vectorUrlDownload() {
      return this.actualVector ? this.actualVector.urlDownload : '';
    },
    isSubscription() {
      return this.openPlan.recurrent ? 'yes' : 'no';
    },
    periodAv() {
      if (this.openPlan.chargeFrecuency == 'ANNUALLY') {
        return '/year';
      } else if (this.openPlan.chargeFrecuency == 'MONTHLY') {
        return '/mo';
      } else {
        return '';
      }
    }
  },
  destroyed() {
    this.error = false;
    this.custom = '';
  },
  methods: {
    buildCustom() {
      if (this.$auth.user.idUser) {
        let customValues = {
          idPlan: this.openPlan.id,
          '@idVexelsUser': this.$auth.user.idUser,
          '@isSubscription': this.isSubscription,
          '@redirectVector': this.vectorId,
          '@vectorUrlDownload': this.vectorUrlDownload,
          '@idVector': this.vectorId,
          '@lang': this.$i18n.locale,
          '@country_code': this.$auth.user.countryCode,
          '@country_name': this.$auth.user.countryName,
          '@costPlan': this.openPlan.cost
        };

        let customTmp = '';

        for (var [key, value] of Object.entries(customValues)) {
          customTmp += key + ':' + value;
        }

        this.custom = customTmp;
      }
    },
    submitFormPayPal() {
      this.$auth.fetchUser(true);
      this.buildCustom();
      if (this.custom) {
        setTimeout(() => {
          this.$refs.formPaypal.submit();
        }, 300);
      } else {
        let vxId = this.$cookies.get('vx.id');
        let vxStrategy = this.$cookies.get('vx.strategy');
        let vxToken = this.$cookies.get(`vx.token.${vxStrategy}`);
        let dataError = { vxId, vxStrategy, vxToken };
        this.error = true;
        console.error('Submit Form PayPal', this.custom);
        this.$ga.event('website-error', 'Custom empty', JSON.stringify(dataError));
      }
    },
    buildUrl(url = '') {
      return window.location.origin + `/${url}`;
    }
  }
};
</script>

<style lang="scss" scoped>
.paypal-container {
  color: #bbbbbb;
}
.data-text {
  font-weight: 500;
}
</style>
